import React, { forwardRef, memo } from "react";
import { Button, EmptyState, EmptyStateIconBackground, EmptyStateProps } from "../../ui";
import { GlobalErrorBannerIcon } from "./GlobalErrorBannerIcon";
import { mapEmptyStateSizeToButtonSize } from "./utils";

export type GlobalErrorBannerProps = EmptyStateProps & {
  supportLink?: string
}

export const GlobalErrorBanner = memo(forwardRef<HTMLDivElement, GlobalErrorBannerProps>((
  {
    size = "sm",
    header = "Oops! Something went wrong",
    supportLink = "/support",
    ...restProps
  }, ref) => {
  return (
    <EmptyState
      size={size}
      header={header}
      supportingText={(
        <>
          {"Please contact technical support at "}
          <Button
            style={{ display: "inline-block" }}
            buttonSize={mapEmptyStateSizeToButtonSize(size)}
            component={"a"}
            buttonType={"linkGray"}
            children={"support@tecorien.com"}
            href="mailto:support@tecorien.com"
          />
          {" or you can get live support using this "}
          <Button
            style={{ display: "inline-block" }}
            buttonSize={mapEmptyStateSizeToButtonSize(size)}
            component={"a"}
            buttonType={"linkGray"}
            href={supportLink}
            children={"link"}
            rel={"noopener noreferrer"}
            target={"_blank"}
          />
        </>
      )}
      icon={(
        <EmptyStateIconBackground type="circle">
          <GlobalErrorBannerIcon size={size} />
        </EmptyStateIconBackground>
      )}
      children={(
        <Button
          onClick={() => window.location.reload()}
          children={"Refresh page"}
          buttonSize={mapEmptyStateSizeToButtonSize(size)}
        />
      )}
      {...restProps}
      ref={ref}
    />
  );
}));
